import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/
var RealtimePresence = /*#__PURE__*/function () {
  /**
   * Initializes the Presence.
   *
   * @param channel - The RealtimeSubscription
   * @param opts - The options,
   *        for example `{events: {state: 'state', diff: 'diff'}}`
   */
  function RealtimePresence(channel, opts) {
    var _this = this;

    _classCallCheck(this, RealtimePresence);

    this.channel = channel;
    this.state = {};
    this.pendingDiffs = [];
    this.joinRef = null;
    this.caller = {
      onJoin: function onJoin() {},
      onLeave: function onLeave() {},
      onSync: function onSync() {}
    };
    var events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
      state: 'presence_state',
      diff: 'presence_diff'
    };
    this.channel.on(events.state, {}, function (newState) {
      var _this$caller = _this.caller,
          onJoin = _this$caller.onJoin,
          onLeave = _this$caller.onLeave,
          onSync = _this$caller.onSync;
      _this.joinRef = _this.channel.joinRef();
      _this.state = RealtimePresence.syncState(_this.state, newState, onJoin, onLeave);

      _this.pendingDiffs.forEach(function (diff) {
        _this.state = RealtimePresence.syncDiff(_this.state, diff, onJoin, onLeave);
      });

      _this.pendingDiffs = [];
      onSync();
    });
    this.channel.on(events.diff, {}, function (diff) {
      var _this$caller2 = _this.caller,
          onJoin = _this$caller2.onJoin,
          onLeave = _this$caller2.onLeave,
          onSync = _this$caller2.onSync;

      if (_this.inPendingSyncState()) {
        _this.pendingDiffs.push(diff);
      } else {
        _this.state = RealtimePresence.syncDiff(_this.state, diff, onJoin, onLeave);
        onSync();
      }
    });
  }
  /**
   * Used to sync the list of presences on the server with the
   * client's state.
   *
   * An optional `onJoin` and `onLeave` callback can be provided to
   * react to changes in the client's local presences across
   * disconnects and reconnects with the server.
   */


  _createClass(RealtimePresence, [{
    key: "onJoin",
    value: function onJoin(callback) {
      this.caller.onJoin = callback;
    }
  }, {
    key: "onLeave",
    value: function onLeave(callback) {
      this.caller.onLeave = callback;
    }
  }, {
    key: "onSync",
    value: function onSync(callback) {
      this.caller.onSync = callback;
    }
  }, {
    key: "list",
    value: function list(by) {
      return RealtimePresence.list(this.state, by);
    }
  }, {
    key: "inPendingSyncState",
    value: function inPendingSyncState() {
      return !this.joinRef || this.joinRef !== this.channel.joinRef();
    }
  }], [{
    key: "syncState",
    value: function syncState(currentState, newState, onJoin, onLeave) {
      var state = this.cloneDeep(currentState);
      var transformedState = this.transformState(newState);
      var joins = {};
      var leaves = {};
      this.map(state, function (key, presences) {
        if (!transformedState[key]) {
          leaves[key] = presences;
        }
      });
      this.map(transformedState, function (key, newPresences) {
        var currentPresences = state[key];

        if (currentPresences) {
          var newPresenceIds = newPresences.map(function (m) {
            return m.presence_id;
          });
          var curPresenceIds = currentPresences.map(function (m) {
            return m.presence_id;
          });
          var joinedPresences = newPresences.filter(function (m) {
            return curPresenceIds.indexOf(m.presence_id) < 0;
          });
          var leftPresences = currentPresences.filter(function (m) {
            return newPresenceIds.indexOf(m.presence_id) < 0;
          });

          if (joinedPresences.length > 0) {
            joins[key] = joinedPresences;
          }

          if (leftPresences.length > 0) {
            leaves[key] = leftPresences;
          }
        } else {
          joins[key] = newPresences;
        }
      });
      return this.syncDiff(state, {
        joins: joins,
        leaves: leaves
      }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     */

  }, {
    key: "syncDiff",
    value: function syncDiff(state, diff, onJoin, onLeave) {
      var _this2 = this;

      var _joins$leaves = {
        joins: this.transformState(diff.joins),
        leaves: this.transformState(diff.leaves)
      },
          joins = _joins$leaves.joins,
          leaves = _joins$leaves.leaves;

      if (!onJoin) {
        onJoin = function onJoin() {};
      }

      if (!onLeave) {
        onLeave = function onLeave() {};
      }

      this.map(joins, function (key, newPresences) {
        var currentPresences = state[key];
        state[key] = _this2.cloneDeep(newPresences);

        if (currentPresences) {
          var _state$key;

          var joinedPresenceIds = state[key].map(function (m) {
            return m.presence_id;
          });
          var curPresences = currentPresences.filter(function (m) {
            return joinedPresenceIds.indexOf(m.presence_id) < 0;
          });

          (_state$key = state[key]).unshift.apply(_state$key, _toConsumableArray(curPresences));
        }

        onJoin(key, currentPresences, newPresences);
      });
      this.map(leaves, function (key, leftPresences) {
        var currentPresences = state[key];
        if (!currentPresences) return;
        var presenceIdsToRemove = leftPresences.map(function (m) {
          return m.presence_id;
        });
        currentPresences = currentPresences.filter(function (m) {
          return presenceIdsToRemove.indexOf(m.presence_id) < 0;
        });
        state[key] = currentPresences;
        onLeave(key, currentPresences, leftPresences);
        if (currentPresences.length === 0) delete state[key];
      });
      return state;
    }
    /**
     * Returns the array of presences, with selected metadata.
     */

  }, {
    key: "list",
    value: function list(presences, chooser) {
      if (!chooser) {
        chooser = function chooser(_key, pres) {
          return pres;
        };
      }

      return this.map(presences, function (key, presences) {
        return chooser(key, presences);
      });
    }
  }, {
    key: "map",
    value: function map(obj, func) {
      return Object.getOwnPropertyNames(obj).map(function (key) {
        return func(key, obj[key]);
      });
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_id'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_id: '2', user_id: 1 },
     *    { presence_id: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     */

  }, {
    key: "transformState",
    value: function transformState(state) {
      state = this.cloneDeep(state);
      return Object.getOwnPropertyNames(state).reduce(function (newState, key) {
        var presences = state[key];

        if ('metas' in presences) {
          newState[key] = presences.metas.map(function (presence) {
            presence['presence_id'] = presence['phx_ref'];
            delete presence['phx_ref'];
            delete presence['phx_ref_prev'];
            return presence;
          });
        } else {
          newState[key] = presences;
        }

        return newState;
      }, {});
    }
  }, {
    key: "cloneDeep",
    value: function cloneDeep(obj) {
      return JSON.parse(JSON.stringify(obj));
    }
  }]);

  return RealtimePresence;
}();

export { RealtimePresence as default };